<style rel="stylesheet/scss" lang="scss" scoped="scoped">

  .newsContent {
    width: 1200px;
    margin: 120px auto 60px;
    .newsleft {
      width: 310px;
      .titleimg {
        height: 51px;
        margin-bottom: 26px;
      }
      .title {
        width: 310px;
        font-size: 42px;
        color: #1b1b1b;
        padding-bottom: 30px;
        border-bottom: 1px solid #1b90ef;
      }
    }
    .newsContainer {
      margin-left: 60px;
      width: calc(100% - 350px);
      .contentTtitle {
        margin-bottom: 28px;
      }
      .subtitle {
        margin-top: 24px;
        margin-bottom: 28px;
      }
      .product {
        .searchbox {
          .searchicon {
            height: 17px;
            width: 17px;
            position: absolute;
          }
          .searchinput {
            position: relative;
            height: 50px;
            line-height: 50px;
            border: 1px solid #ececec;
            width: 664px;
            text-indent: 20px;
            margin-bottom: 28px;
          }
          .searchbutton {
            background: #1b90ef;
            width: 340px;
            text-align: center;
            height: 50px;
            line-height: 50px;
            color: #fff;
          }
        }
        .table {
          font-size: 14px;
          table-layout: fixed;
          tr {
            width:auto;
            font-weight: 600;
            th {
              background: #f9f9f9;
              height: 40px;
              line-height: 40px;
              border: 1px solid #f4f4f4;
              font-weight: 600;
              padding: 6px;
            }
            td {
              border: 1px solid #f4f4f4;
              padding: 12px;
              word-break: break-all;
              font-weight: 300;
              height: 100px;
            }
          }
        }
      }
    }
  }
  .leftheader {
    width: 100%;
    color: #666;
    >ul {
      width: 100%;
      >li {
        width: 100%;
        cursor: pointer; // float: left;
        text-align: center;
        line-height: 60px;
        color: #000;
        letter-spacing: 3px;
        font-size: 16px;
        .itemCemter {
          display: flex;
          align-items: center;
          .ml6 {
            margin-left: 6px;
          }
          .greyline {
            background: #000;
            display: inline-block;
            height: 1px;
            width: 6px;
            margin: 0 40px;
          }
          .activeline {
            background: #1b90ef;
            display: inline-block;
            height: 1px;
            width: 6px;
            margin: 0 40px;
          }
        }
        &:hover {
          color: #1b90ef;
        }
        >ul {
          width: 100%;
          background: #fff;
          text-align: left;
          margin-left: 85px;
          color: #000;
          li {
            &:hover {
              color: #1b90ef;
            }
          }
          .activesub {
            color: #1b90ef;
          }
        }
      }
      .active {
        color: #1b90ef;
      }
    }
  }
</style>
<template>
  <div class="newsBox">
    <Head :selectindex="selectindex"></Head>
    <div class="contentflex">
      <div class="newsContent flex">
        <div class="newsleft">
          <img class="titleimg" src='../assets/images/Information.png' />
          <div class="title">信息披露</div>
          <div class="leftheader">
            <ul>
              <li :class="[{active:item.show}]" @click="changeli(index,item)" v-for="(item,index) in headerData" :key="index">
                <div class="itemCemter"> <span :class="item.show?'activeline':'greyline'"></span>{{item.name}}</div>
                <ul v-show="item.show">
                  <li v-for="(ite,inde) in item.list" :class="subactive==inde?'activesub':''" v-on:click.stop="doThis(ite,inde)" :key="inde">{{ite.name}}</li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="newsContainer">
          <div class="contentTtitle font36">{{title}}</div>
          <div v-if="showContent">
            <div class="subtitle font18 itemCenter"></div>
            <div class="tableBox" v-html="content">
            </div>
          </div>
          <div v-if="!showContent">
            <div class="product">
              <div v-if="showproduct">
                <div class="searchbox flex">
                  <img src="../assets/images/searchicon.png" class="searchicon" />
                  <input type="text" v-model="productName" placeholder="承保公司/销售产品名称/产品链接/备案产品/条款名称/备案编号/验真途径" class="searchinput" />
                  <div class="searchbutton" @click="getproduct('search')">查询</div>
                </div>
                <table class="table"  v-if="noData">
                  <tr>
                    <th v-for="item in sortDatas">
                      {{item.name}}
                    </th>
                  </tr>
                  <tr v-for="(item,index) in tabledata" :key="item.id">
                    <td>
                      {{item.companyName}}
                    </td>
                    <td>
                      {{item.productName}}
                    </td>
                    <td>
                      {{item.productUrl}}
                    </td>
                    <td>
                      {{item.recordName}}
                    </td>
                    <td>
                      {{item.recordNumber}}
                    </td>
                    <td>
                      {{item.verificationMethod}}
                    </td>
                  </tr>
                </table>
              </div>
              <div v-if="showcompany">
                <div class="searchbox flex">
                  <img src="../assets/images/searchicon.png" class="searchicon" />
                  <input type="text" v-model="name" placeholder="公司名称" class="searchinput" />
                  <div class="searchbutton" @click="getcompany('search')">查询</div>
                </div>
                <table class="table" v-if="noData">
                  <tr>
                    <th v-for="item in companysortDatas">
                      {{item.name}}
                    </th>
                  </tr>
                  <tr v-for="(item,index) in tabledata" :key="item.id">
                    <td>
                      {{item.name}}
                    </td>
                    <td>
                      {{timetrans(item.cooperationStartDate)}}至{{timetrans(item.cooperationEndDate)}}
                    </td>
                    <td>
                      {{item.cooperationScope}}
                    </td>
                    <td>
                      {{item.serviceProvince}}
                    </td>
                    <td>
                      {{item.serviceTel}}
                    </td>
                    <td>
                      {{item.serviceMethod}}
                    </td>
                    <td>
                      {{item.serviceInfo}}
                    </td>
                  </tr>
                </table>
              </div>
              <div v-if="showintermediary">
                <div class="searchbox flex">
                  <img src="../assets/images/searchicon.png" class="searchicon" />
                  <input type="text" v-model="companyName" placeholder="公司名称" class="searchinput" />
                  <div class="searchbutton" @click="getintermediary('search')">查询</div>
                </div>
                <table class="table" v-if="noData">
                  <tr>
                    <th v-for="item in intermediarysortDatas">
                      {{item.name}}
                    </th>
                  </tr>
                  <tr v-for="(item,index) in tabledata" :key="item.id">
                    <td>
                      {{item.companyName}}
                    </td>
                    <td>
                      {{item.websiteUrl}}
                    </td>
                    <td>
                      {{timetrans(item.cooperationStartDate)}}至{{timetrans(item.cooperationEndDate)}}
                    </td>
                    <td>
                      {{item.cooperationContent.length>20?item.cooperationContent.length.substring(0,20)+'...':item.cooperationContent}}
                    </td>
                  </tr>
                </table>
              </div>
              <div class="block" v-if="noData">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" :page-size="size" :page-sizes="[5,10]" layout="total,sizes,prev, pager, next,jumper" :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer-content></footer-content>
    </div>

  </div>
</template>
<script>
  import Head from '../components/headercontent'
  import Service from '../common/service'
  import footerContent from '../components/footercontent'
  export default {
    name: "productserver",
    data() {
      return {
        name: '',
        companyName: '',
        productName: '',
        showproduct: false,
        showcompany: false,
        showintermediary: false,
        noData: false,
        tabledata: [],
        showContent: true,
        content: '',
        title: '',
        subactive: 0,
        selectindex: 2,
        sortDatas: [{
            orderType: '',
            name: '承保公司',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '销售产品名称',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '产品链接',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '备案产品/条款名称',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '备案编号',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '验真途径',
            showBlue: false,
            orderField: ''
          },
        ],
        companysortDatas: [{
            orderType: '',
            name: '公司名称',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '合作期限',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '合作范围',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '省级分支机构和落地服务机构的省',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '全国统一客服电话',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '在线服务访问方式',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '偿付能力、风险综合评级、消费者权益保护',
            showBlue: false,
            orderField: ''
          }
        ],
        intermediarysortDatas: [{
            orderType: '',
            name: '公司名称',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '官网地址',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '合作期限',
            showBlue: false,
            orderField: ''
          },
          {
            orderType: '',
            name: '合作内容',
            showBlue: false,
            orderField: ''
          }
        ],
        headerData: [{
          name: '消费者权益保护',
          list: [],
          show: false,
          showContent: true
        }, {
          name: '互联网保险产品',
          list: [],
          show: false,
          showContent: false
        }, {
          name: '合作保险公司',
          list: [],
          show: false,
          showContent: false
        }, {
          name: '保险中介合作机构',
          list: [],
          show: false,
          showContent: false
        }],
        showLoading: true,
        page: 1,
        size: 10,
        busy: false
      }
    },
    created() {
      $('.navbar').removeClass('fixed-topone');
      document.getElementsByTagName("title")[0].innerHTML = "信息披露";
      this.information(3);
      this.information(4);
    },
    mounted() {
      $('html , body').animate({
        scrollTop: 0
      }, 'slow');
    },
    methods: {
      information(id) {
        Service.information().getinformation({}, id).then(response => {
          var data = response.data.reverse();
          if(id == 3) {
            this.content = data[data.length - 1].content;
            for(let item of data) {
              var obj = {
                name: item.name,
                show: false,
                id: item.id,
                showContent: true
              }
              this.headerData.unshift(obj)

            }
            this.title = this.headerData[0].name;
            this.headerData[0].show = true;
          } else if(id == 4) {
            for(let item of this.headerData) {
              if(item.name == '消费者权益保护') {
                item.list = data;
              }
            }
          }

        }, err => {
          console.log(err);
        });
      },
      getinformation(id) {
        Service.information().informationdetail({}, id).then(response => {
          this.content = response.data.content;
        }, err => {
          console.log(err);
        });
      },
      getproduct() {
        console.log('产品')
        Service.product().postproduct({
          page: this.page,
          size: this.size,
          keyword: this.productName,
        }).then(response => {
          this.tabledata = response.data.records;
          this.total = response.data.total;
          console.log(this.noData, this.tabledata)
          if(this.tabledata.length > 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        }, err => {
          console.log(err);
        });
      },
      getcompany() {
        Service.company().postcompany({
          page: this.page,
          size: this.size,
          name: this.name,
        }).then(response => {
          this.tabledata = response.data.records;
          this.total = response.data.total;
          console.log(this.noData, this.tabledata)
          if(this.tabledata.length > 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        }, err => {
          console.log(err);
        });
      },
      getintermediary() {
        Service.intermediary().postintermediary({
          page: this.page,
          size: this.size,
          companyName: this.companyName,
        }).then(response => {
          this.tabledata = response.data.records;
          this.total = response.data.total;
          console.log(this.noData, this.tabledata)
          if(this.tabledata && this.tabledata.length > 0) {
            this.noData = true;
          } else {
            this.noData = false;
          }
        }, err => {
          console.log(err);
        });
      },
      handleSizeChange(val) {
        this.size = val;
        if(this.showproduct) {
          this.getproduct('')
        } else if(this.showcompany) {
          this.getcompany('')
        } else if(this.showintermediary) {
          this.getintermediary('')
        }
      },
      handleCurrentChange(val) {
        this.page = val;
        if(this.showproduct) {
          this.getproduct('')
        } else if(this.showcompany) {
          this.getcompany('')
        } else if(this.showintermediary) {
          this.getintermediary('')
        }
      },
      changeli(ind, item) {
        // 先循环数据中的show将其全部置为false,此时模板里的v-if判断生效关闭全部二级菜单,并移除样式
        this.headerData.forEach(i => {
          // 判断如果数据中的headerData[i]的show属性不等于当前数据的show属性那么headerData[i]等于false
          if(i.show !== this.headerData[ind].show) {
            i.show = false;
          };
        });
        // 取反(true或false)
        item.show = !item.show;
        if(this.title == item.name) {
          item.show = true;
        }
        this.title = item.name;
        this.showContent = item.showContent;
        if(item.id) {
          this.getinformation(item.id)
        }
        if(item.name == '互联网保险产品') {
          this.getproduct()
          this.page = 1;
          this.showproduct = true;
          this.showcompany = false;
          this.showintermediary = false;
        } else if(item.name == '合作保险公司') {
          this.getcompany()
          this.page = 1;
          this.showcompany = true;
          this.showintermediary = false;
          this.showproduct = false;
        } else if(item.name == '保险中介合作机构') {
          this.page = 1;
          this.getintermediary()
          this.showintermediary = true;
          this.showcompany = false;
          this.showproduct = false;
        } else if(item.name == '消费者权益保护') {
          console.log(item.list)
          this.doThis(item.list[0], 0)
        }

      },
      doThis(item, index) {
        this.subactive = index;
        this.title = item.name;
        if(item.id) {
          this.getinformation(item.id)
        }
      },

      timetrans(timestamp) {
        var getSeconds = '',
          getMinutes = '',
          getHours = '';
        var d = new Date(timestamp);
        getHours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
        getMinutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes()
        getSeconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds()
        var newTime = d.getFullYear() + '年' + (d.getMonth() + 1) + '月' + d.getDate() + '日 ';
        // + getHours + ':' + getMinutes + ':' + getSeconds;
        return newTime
      },
      handleFun() {
        // 页面滚动距顶部距离
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop ||
          document.body.scrollTop
        var scroll = scrollTop - this.i;
        this.i = scrollTop;
        var height = $('.navbar').height()
        if($(window).scrollTop() >= height) {
          $('.navbar').css({
            'margin-top': '-100px'
          }).addClass('fixed-top');
        } else {
          if(scroll < 0) { //向上滚动
            $('.navbar').css({
              'margin-top': '0px'
            }).removeClass('fixed-top')
          }
        }
      },
      chengeheader(index) {
        var obj = $(".spanborder")
        for(var i = 0; i < obj.length; i++) {
          obj[i].className = 'spanborder'
          obj[index].className = 'spanborder active'
        }
      },
      scrollHeight(data) {
        var height = $('.' + data).offset().top;
        $('html,body').animate({
          scrollTop: height
        }, 500);
        // $(window).scrollTop(height)
      }
    },
    components: {
      Head,
      footerContent
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.handleFun, true)
    },
  }
</script>


// WEBPACK FOOTER //
// src/views/infomation.vue